// import { useEffect, useState } from "react";
// import {
//   getDocs,
//   collection,
//   updateDoc,
//   doc,
//   deleteDoc,
// } from "firebase/firestore";
// import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { db } from "../../firebase";
// import css from "./blogeditor.module.css";

// const BlogListEditor = () => {
//   const [articles, setArticles] = useState([]);
//   const [editingArticle, setEditingArticle] = useState(null);
//   const [newPhotoFile, setNewPhotoFile] = useState(null);

//   const objList = [
//     { name: "Заголовок", transliter: "zag" },
//     { name: "Перший опис", transliter: "chortDesc" },
//     { name: "Другий опис", transliter: "centrDesc" },
//     { name: "Третій", transliter: "longDesc" },
//     { name: "ID відео", transliter: "videoId" },
//   ];

//   const fetchArticles = async () => {
//     const snapshot = await getDocs(collection(db, "blog"));
//     const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//     setArticles(docs);
//   };

//   useEffect(() => {
//     fetchArticles();
//   }, []);

//   const handleEdit = (article) => {
//     setEditingArticle({ ...article });
//     setNewPhotoFile(null);
//   };

//   const handleChange = (field, value) => {
//     setEditingArticle((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleFileChange = (e) => {
//     setNewPhotoFile(e.target.files[0]);
//   };

//   const handleSave = async () => {
//     if (!editingArticle) return;

//     try {
//       let updatedArticle = { ...editingArticle };

//       if (newPhotoFile) {
//         const storage = getStorage();
//         const storageRef = ref(
//           storage,
//           `blog/${editingArticle.id}/${newPhotoFile.name}`
//         );
//         await uploadBytes(storageRef, newPhotoFile);
//         const downloadURL = await getDownloadURL(storageRef);
//         updatedArticle.photo = downloadURL;
//       }

//       const refDoc = doc(db, "blog", editingArticle.id);
//       await updateDoc(refDoc, updatedArticle);
//       setEditingArticle(null);
//       fetchArticles();
//     } catch (error) {
//       console.error("Помилка при оновленні статті:", error);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Ви впевнені, що хочете видалити цю статтю?")) return;
//     await deleteDoc(doc(db, "blog", id));
//     fetchArticles();
//   };

//   return (
//     <div className={css.divForList}>
//       <h2>Редактор блогу</h2>

//       {articles.map((a) => (
//         <div key={a.id} className={css.listLiProd}>
//           <p>
//             <strong>{a.zag}</strong>
//           </p>
//           <button onClick={() => handleEdit(a)}>Редагувати</button>
//           <button onClick={() => handleDelete(a.id)}>Видалити</button>
//         </div>
//       ))}

//       {editingArticle && (
//         <div className={css.editSection}>
//           <h3>Редагування статті</h3>
//           {objList.map((field) => (
//             <div key={field.transliter} className={css.wrapSmallList}>
//               <p className={css.paramBooks}>{field.name}</p>
//               <input
//                 type="text"
//                 value={editingArticle[field.transliter] || ""}
//                 onChange={(e) => handleChange(field.transliter, e.target.value)}
//               />
//             </div>
//           ))}

//           <div className={css.wrapSmallList}>
//             <p className={css.paramBooks}>Фото</p>
//             {editingArticle.photo && (
//               <div style={{ marginBottom: "8px" }}>
//                 <a
//                   href={editingArticle.photo}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   Переглянути поточне фото
//                 </a>
//               </div>
//             )}
//             <input type="file" onChange={handleFileChange} />
//           </div>

//           <button onClick={handleSave} className={css.addBookButtonBlog}>
//             Зберегти
//           </button>
//           <button onClick={() => setEditingArticle(null)}>Скасувати</button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BlogListEditor;
import { useEffect, useState } from "react";
import {
  getDocs,
  collection,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase";
import css from "./blogeditor.module.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const BlogListEditor = () => {
  const [articles, setArticles] = useState([]);
  const [editingArticle, setEditingArticle] = useState(null);
  const [newPhotoFile, setNewPhotoFile] = useState(null);

  const objList = [
    { name: "Заголовок", transliter: "zag" },
    { name: "Перший опис", transliter: "chortDesc" },
    { name: "SEO title", transliter: "seoTitle" },
    { name: "SEO description", transliter: "seoDescription" },
    { name: "ID відео", transliter: "videoId" },
  ];

  const fetchArticles = async () => {
    const snapshot = await getDocs(collection(db, "blog"));
    const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setArticles(docs);
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const handleEdit = (article) => {
    setEditingArticle({ ...article });
    setNewPhotoFile(null);
  };

  const handleChange = (field, value) => {
    setEditingArticle((prev) => ({ ...prev, [field]: value }));
  };

  const handleFileChange = (e) => {
    setNewPhotoFile(e.target.files[0]);
  };

  const handleSave = async () => {
    if (!editingArticle) return;

    try {
      let updatedArticle = { ...editingArticle };

      if (updatedArticle.longDesc) {
        updatedArticle.longDesc = updatedArticle.longDesc.replace(
          /<p><br><\/p>/g,
          '<div class="spacer"></div>'
        );
      }

      if (newPhotoFile) {
        const storage = getStorage();
        const storageRef = ref(
          storage,
          `blog/${editingArticle.id}/${newPhotoFile.name}`
        );
        await uploadBytes(storageRef, newPhotoFile);
        const downloadURL = await getDownloadURL(storageRef);
        updatedArticle.photo = downloadURL;
      }

      const refDoc = doc(db, "blog", editingArticle.id);
      await updateDoc(refDoc, updatedArticle);
      setEditingArticle(null);
      fetchArticles();
    } catch (error) {
      console.error("Помилка при оновленні статті:", error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Ви впевнені, що хочете видалити цю статтю?")) return;
    await deleteDoc(doc(db, "blog", id));
    fetchArticles();
  };

  return (
    <div className={css.divForList}>
      <h2>Редактор блогу</h2>

      {articles.map((a) => (
        <div key={a.id} className={css.listLiProd}>
          <p>
            <strong>{a.zag}</strong>
          </p>
          <button onClick={() => handleEdit(a)}>Редагувати</button>
          <button onClick={() => handleDelete(a.id)}>Видалити</button>
        </div>
      ))}

      {editingArticle && (
        <div className={css.editSection}>
          <h3>Редагування статті</h3>

          {objList.map((field) => (
            <div key={field.transliter} className={css.wrapSmallList}>
              <p className={css.paramBooks}>{field.name}</p>
              <input
                type="text"
                value={editingArticle[field.transliter] || ""}
                onChange={(e) => handleChange(field.transliter, e.target.value)}
              />
            </div>
          ))}

          <div className={css.wrapSmallList}>
            <p className={css.paramBooks}>Третій (довгий опис)</p>
            <ReactQuill
              value={editingArticle.longDesc || ""}
              onChange={(value) => handleChange("longDesc", value)}
              className={css.quillEditornewBlog}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],
                  ["bold", "italic", "underline", "strike", "link"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  [{ align: [] }],
                  ["clean"],
                ],
              }}
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "link",
                "list",
                "bullet",
                "align",
              ]}
            />
          </div>

          <div className={css.wrapSmallList}>
            <p className={css.paramBooks}>Фото</p>
            {editingArticle.photo && (
              <div style={{ marginBottom: "8px" }}>
                <a
                  href={editingArticle.photo}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Переглянути поточне фото
                </a>
              </div>
            )}
            <input type="file" onChange={handleFileChange} />
          </div>

          <div className={css.wrapSmallList}>
            <label className={css.paramBooks}>
              <input
                type="checkbox"
                checked={!!editingArticle.check}
                onChange={(e) => handleChange("check", e.target.checked)}
              />
              &nbsp;Посилання на сторонній сайт
            </label>
          </div>

          {editingArticle.check && (
            <div className={css.wrapSmallList}>
              <p className={css.paramBooks}>Посилання</p>
              <input
                type="text"
                value={editingArticle.linkto || ""}
                onChange={(e) => handleChange("linkto", e.target.value)}
              />
            </div>
          )}

          <button onClick={handleSave} className={css.addBookButtonBlog}>
            Зберегти
          </button>
          <button onClick={() => setEditingArticle(null)}>Скасувати</button>
        </div>
      )}
    </div>
  );
};

export default BlogListEditor;
